module.exports = __webpack_public_path__ + "static/img/main.5567aa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/3/main.png
// module id = uhP9
// module chunks = 1